import Icon from 'tailwind/components/Icon/Icon';
import type { SmallIconProps } from 'tailwind/components/Icon/Icon.types';

// Temporary port of an icon while we work to address `zappos-ui` publishing errors
// https://zappos.atlassian.net/browse/FEE-3667

const BellSmallIcon = (props: SmallIconProps) => (
  <Icon {...props} viewBox="0 0 16 16">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.2"
      d="M9.153 14a1.333 1.333 0 0 1-2.306 0M12 5.333a4 4 0 1 0-8 0c0 4.667-2 6-2 6h12s-2-1.333-2-6"
    ></path>
  </Icon>
);

export default BellSmallIcon;
